<template>
  <div>
    <CustomCallout
      :has-toggle="true"
      class="mt-2 deep grouped-saee"
      :border-color-hex="value.statusColor"
      :opened="open"
      :controlled="true"
      @click:open="toggleOpen"
    >
      <div class="grouped-saee__row">
        <div class="grouped-saee__status border-right">
          <span
            class="grouped-saee__status-pill"
            :style="{ backgroundColor: value.statusColor }"
          >
            {{ value.status }}
          </span>
        </div>

        <div class="grouped-saee__content">
          <div class="grouped-saee__field">
            <div class="info-text-title">Nombre del Estudiante:</div>
            <p>{{ studentDisplayName }}</p>
          </div>
          <div class="grouped-saee__field">
            <div class="info-text-title">Centro:</div>
            <p>{{ value.center || '-' }}</p>
          </div>
          <div class="grouped-saee__field">
            <div class="info-text-title">Municipio:</div>
            <p>{{ value.municipality || '-' }}</p>
          </div>
          <div class="grouped-saee__field">
            <div class="info-text-title">Escuela:</div>
            <p>{{ value.schoolName || '-' }}</p>
          </div>
          <div class="grouped-saee__field">
            <div class="info-text-title">Impedimento:</div>
            <p>{{ value.impediment || '-' }}</p>
          </div>
          <div class="grouped-saee__field">
            <div class="info-text-title">Necesidad(es):</div>
            <p>{{ value.necesities || '-' }}</p>
          </div>
        </div>

        <div class="grouped-saee__actions">
          <Dropdown name="Actions" title="Acciones" :items="groupActions" />
          <div class="grouped-saee__count">
            Conteo SAEE 10: {{ saee10Count }}
          </div>
        </div>
      </div>
    </CustomCallout>

    <div v-if="open" class="tab-container p-2">
      <div class="white-container">
        <custom-tab
          :key="activeTab"
          v-model="activeTab"
          content-class="mt-3"
          :default-active-tab="activeTab"
          :no-nav-style="true"
          class="custom-tab-font"
          nav-class="nav-vue-underline"
        >
          <custom-tab-item class="mt-2 mt-3" title="Información Adicional">
            <div class="additional-info">
              <div>
                <div class="info-text-title">Nombre del Estudiante:</div>
                <p>{{ studentDisplayName }}</p>
              </div>
              <div>
                <div class="info-text-title">Edad:</div>
                <p>{{ value.studentAge || '-' }}</p>
              </div>
              <div>
                <div class="info-text-title">Grado:</div>
                <p>{{ value.studentGrade || '-' }}</p>
              </div>
              <div>
                <div class="info-text-title">Necesidad(es):</div>
                <p>{{ value.necesities || '-' }}</p>
              </div>
              <div>
                <div class="info-text-title">Impedimento:</div>
                <p>{{ value.impediment || '-' }}</p>
              </div>
            </div>
          </custom-tab-item>

          <custom-tab-item class="mt-2 mt-3" title="Detalles SAEE 10">
            <div class="saee10-details">
              <div
                v-for="detail in saee10Details"
                :key="detail.id"
                class="saee10-detail-wrapper"
              >
                <div class="saee10-detail">
                  <div class="saee10-detail__status">
                    <span
                      class="saee10-detail__status-pill"
                      :style="{ backgroundColor: detail.statusColor }"
                    >
                      {{ detail.status }}
                    </span>
                    <span class="saee10-detail__request text-center">
                      {{ detail.requestNumber }}
                    </span>
                  </div>

                  <div class="saee10-detail__field">
                    <div class="info-text-title">Número de Solicitud:</div>
                    <p>
                      {{
                        detail.hrRequestNumber || detail.relatedRequest || '-'
                      }}
                    </p>
                  </div>

                  <div class="saee10-detail__field">
                    <div class="info-text-title">Necesidad(es):</div>
                    <p>{{ detail.necesities || '-' }}</p>
                  </div>

                  <div class="saee10-detail__assistant">
                    <div class="info-text-title mb-1">Asistente:</div>
                    <div
                      v-if="showAssistantDropdown(detail)"
                      class="assistant-assignment"
                    >
                      <div class="assistant-multiselect">
                        <button
                          type="button"
                          class="assistant-multiselect__button"
                          @click.stop="toggleAssistantDropdown(detail)"
                        >
                          <span class="assistant-multiselect__text">
                            {{ selectedOptionText(detail) || 'Seleccione' }}
                          </span>
                          <i
                            class="fas fa-chevron-down assistant-multiselect__caret"
                          />
                        </button>
                        <div
                          v-if="isAssistantDropdownOpen(detail)"
                          class="assistant-multiselect__menu"
                        >
                          <button
                            v-for="option in assignmentOptions(detail)"
                            :key="
                              `${detail.id}-${
                                option.isAssistant ? 'assistant' : 'option'
                              }-${option.key}`
                            "
                            type="button"
                            class="assistant-multiselect__option"
                            :class="{
                              'assistant-multiselect__option--selected': isOptionSelected(
                                detail,
                                option
                              ),
                            }"
                            @click.stop="
                              onAssignmentOptionClick(detail, option)
                            "
                          >
                            <span>{{ option.value }}</span>
                            <span
                              class="assistant-multiselect__checkbox"
                              :class="{
                                'assistant-multiselect__checkbox--checked': isOptionSelected(
                                  detail,
                                  option
                                ),
                              }"
                            >
                              <i
                                v-if="isOptionSelected(detail, option)"
                                class="fas fa-check"
                              />
                            </span>
                          </button>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="assistant-cancel-button"
                        title="Cancelar"
                        @click.stop="cancelAssistantSelection(detail)"
                      >
                        <i class="fas fa-times-circle" />
                      </button>
                      <button
                        type="button"
                        class="assistant-save-button"
                        title="Guardar asistentes"
                        :disabled="!showAssistantSaveAction(detail)"
                        @click.stop="saveAssistantSelection(detail)"
                      >
                        <i class="fas fa-save" />
                      </button>
                    </div>
                    <p v-else class="assistant-readonly">
                      {{ readonlyAssistantNames(detail) }}
                    </p>
                  </div>

                  <div class="saee10-detail__classification">
                    <span
                      v-if="hasModalityIndicator(detail)"
                      class="saee10-detail__classification-badge"
                      :class="modalityIndicatorClass(detail)"
                    >
                      {{ modalityIndicatorText(detail) }}
                    </span>
                  </div>

                  <div class="saee10-detail__actions">
                    <Dropdown
                      name="Actions"
                      title="Acciones"
                      :items="detailActions(detail)"
                    />
                  </div>
                </div>

                <WarningMessage
                  v-if="showModalityChangeWarning(detail)"
                  class="saee10-detail__modality-warning"
                >
                  <strong>Cambio de modalidad detectado</strong>
                  Esta SAEE cambió de Grupal a Individual, pero tiene
                  {{ modalityChangeAssistantCount(detail) }} asistentes
                  asignados.
                </WarningMessage>
              </div>
            </div>
          </custom-tab-item>
        </custom-tab>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from 'dropdown';
import CustomCallout from 'custom-callout';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import {
  getDeterminationLetterReport,
  getRequestReport,
} from '@/modules/human-resources/api';
import generalService from '@/services/pei/general';
import mixAlert from '@/mixin/alert.mixin';
import { AssignmentTypeEnum } from '@/modules/peiSAEE/assignment-type-enum.js';
import { Saee10StatusEnum } from '@/modules/peiSAEE/saee10-status-enum.js';
import WarningMessage from './components/WarningMessage.vue';

export default {
  name: 'IrregularNecesitiesResultRow',
  mixins: [mixAlert],
  components: {
    Dropdown,
    CustomCallout,
    CustomTab,
    CustomTabItem,
    WarningMessage,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    assistants: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: 0,
      assistantSelectedIdsBySaee10Id: {},
      enabledAssistantDropdownIds: [],
      open: false,
      openAssistantDropdownId: null,
      returnToSchool: 5,
      selectedAssignmentTypeBySaee10Id: {},
    };
  },
  computed: {
    groupActions() {
      return [
        {
          label: 'Información Adicional',
          icon: 'fas fa-info-circle color-primary-1',
          click: () => this.showTab(0),
        },
        {
          label: 'Detalle SAEE 10',
          icon: 'fas fa-list color-primary-1',
          click: () => this.showTab(1),
        },
      ];
    },
    hasAssignmentPermission() {
      return this.$store.getters.HasPermission(
        'rrhh.serviceassistant.assistant.assignment'
      );
    },
    saee10Details() {
      return this.value.saee10Details && this.value.saee10Details.length
        ? this.value.saee10Details
        : [this.value];
    },
    saee10Count() {
      return this.saee10Details.length;
    },
    studentDisplayName() {
      return this.value.studentName || '-';
    },
  },
  methods: {
    assignmentOptions(detail) {
      return detail.assignmentOptions || this.assistants || [];
    },
    assignedAssistants(detail) {
      if (detail.assistants && detail.assistants.length) {
        return detail.assistants;
      }

      return detail.assistant ? [detail.assistant] : [];
    },
    assignedAssistantIds(detail) {
      return this.assignedAssistants(detail)
        .map((x) => x.id || x.Id)
        .filter((id) => id != null);
    },
    assignedAssistantNames(detail) {
      return this.assignedAssistants(detail)
        .map((x) => x.name || x.Name)
        .join(', ');
    },
    readonlyAssistantNames(detail) {
      if (this.assignedAssistantNames(detail)) {
        return this.assignedAssistantNames(detail);
      }

      const assignmentType = this.assignmentOptions(detail).find(
        (option) => !option.isAssistant && option.key == detail.assigmentTypeId
      );

      return assignmentType?.value || '-';
    },
    canChangePendingToAssign(detail) {
      return (
        detail.statusId != Saee10StatusEnum.Pending &&
        this.$store.getters.HasPermission(
          'humanresources.irregularstaff.changestatustopendingtoassign'
        )
      );
    },
    canEnableAssistantDropdown(detail) {
      if (!this.hasAssignmentPermission) return false;

      return [
        Saee10StatusEnum.Pending,
        Saee10StatusEnum.RecommendedExistentResource,
        Saee10StatusEnum.RecommendedPendingAssignment,
        Saee10StatusEnum.InProcessPendingAssignement,
        Saee10StatusEnum.NotRecommendedPendingAssignment,
      ].includes(detail.statusId);
    },
    getAssistantActionLabel(detail) {
      return this.hasAssistantAssignmentValue(detail)
        ? 'Modificar Asistente'
        : 'Asignar Asistente';
    },
    cancelAssistantSelection(detail) {
      this.initializeAssistantSelection(detail);
      this.openAssistantDropdownId = null;
      this.enabledAssistantDropdownIds = this.enabledAssistantDropdownIds.filter(
        (id) => id != detail.id
      );
    },
    changeToPendingToAssign(detail) {
      this.$emit('change-to-pending-assign', detail.id);
    },
    detailActions(detail) {
      return [
        {
          label: 'Entrar',
          border: 'bottom',
          icon: 'fas fa-clipboard-check color-primary-1',
          click: () => this.goToDetail(detail),
        },
        {
          label: 'Imprimir',
          icon: 'fas fa-print color-primary-1',
          click: () => this.onPrintReport(detail),
        },
        {
          label: 'Historial de la SAEE10',
          icon: 'fas fa-clock color-primary-1',
          click: () => this.goToHistory(detail),
        },
        {
          label: 'Descargar Carta de Aprobación',
          icon: 'fas fa-print color-primary-1',
          click: () => this.downloadDeterminationLetter(detail),
          visible:
            detail.statusId == Saee10StatusEnum.ApprovedProvisionalRemedy,
        },
        {
          label: this.getAssistantActionLabel(detail),
          icon: 'fas fa-users-cog color-primary-1',
          click: () => {
            this.enableAssistantDropdown(detail);
          },
          visible: this.canEnableAssistantDropdown(detail),
        },
        {
          label: 'Cambiar a Pendiente de Asignar',
          icon: 'fas fa-redo color-primary-1',
          click: () => this.changeToPendingToAssign(detail),
          visible: this.canChangePendingToAssign(detail),
        },
      ];
    },
    async downloadDeterminationLetter(detail) {
      const missingInformationMessage =
        'No se encontró la información necesaria para descargar la carta de aprobación.';

      try {
        const requestService = detail.provRemRequestService;
        const requiredFields = [
          'requestServiceId',
          'serviceTypeId',
          'serviceStatusId',
        ];

        if (
          !requestService ||
          requiredFields.some((field) => requestService[field] == null)
        ) {
          this.ShowToast('', missingInformationMessage, 'error');
          return;
        }

        const reportParameters = {
          requestServiceId: requestService.requestServiceId,
          serviceTypeId: requestService.serviceTypeId,
          serviceStatusId: requestService.serviceStatusId,
        };

        if (requestService.determinationReasonId != null) {
          reportParameters.determinationReasonId =
            requestService.determinationReasonId;
        }

        if (requestService.determinationReasonCategoryId != null) {
          reportParameters.determinationReasonCategoryId =
            requestService.determinationReasonCategoryId;
        }

        const response = await getDeterminationLetterReport(reportParameters);

        generalService.ConvertToBlob(response.data);
      } catch (error) {
        this.ShowToast(
          '',
          error.response?.data?.message ||
            'No fue posible descargar la carta de aprobación.',
          'error'
        );
      }
    },
    enableAssistantDropdown(detail) {
      this.initializeAssistantSelection(detail);
      if (!this.enabledAssistantDropdownIds.includes(detail.id)) {
        this.enabledAssistantDropdownIds = [
          ...this.enabledAssistantDropdownIds,
          detail.id,
        ];
      }
      this.showTab(1);
      this.openAssistantDropdownId = detail.id;
    },
    goToDetail(detail) {
      this.$router.push({
        path: `/humanres/irregularstaffrequest/saee10/${detail.id}`,
      });
    },
    goToHistory(detail) {
      this.$router.push({
        path: `/humanres/irregularrequest/saee10history/${detail.id}`,
      });
    },
    hasAssignedAssistants(detail) {
      return this.assignedAssistants(detail).length > 0;
    },
    hasAssistantAssignmentValue(detail) {
      return this.hasAssignedAssistants(detail) || !!detail.assigmentTypeId;
    },
    hasAssistantSelectionChanges(detail) {
      const currentIds = [...this.assignedAssistantIds(detail)]
        .sort()
        .join(',');
      const selectedIds = [...this.selectedAssistantIds(detail)]
        .sort()
        .join(',');

      return currentIds != selectedIds;
    },
    hasAssignmentTypeSelectionChanges(detail) {
      return (
        (detail.assigmentTypeId || null) !=
        (this.selectedAssignmentTypeBySaee10Id[detail.id] || null)
      );
    },
    initializeAssistantSelection(detail) {
      const assistantIds = this.assignedAssistantIds(detail);
      this.$set(this.assistantSelectedIdsBySaee10Id, detail.id, assistantIds);
      this.$set(
        this.selectedAssignmentTypeBySaee10Id,
        detail.id,
        assistantIds.length ? null : detail.assigmentTypeId
      );
    },
    initializeAllAssistantSelections() {
      this.saee10Details.forEach((detail) => {
        this.initializeAssistantSelection(detail);
      });
    },
    isAssistantDropdownOpen(detail) {
      return this.openAssistantDropdownId == detail.id;
    },
    isAssistantSelected(detail, assistantId) {
      return this.selectedAssistantIds(detail).some((id) => id == assistantId);
    },
    isAssignmentTypeSelected(detail, option) {
      return (
        !option.isAssistant &&
        !this.selectedAssistantIds(detail).length &&
        option.key == this.selectedAssignmentTypeBySaee10Id[detail.id]
      );
    },
    isOptionSelected(detail, option) {
      return option.isAssistant
        ? this.isAssistantSelected(detail, option.key)
        : this.isAssignmentTypeSelected(detail, option);
    },
    modalityChangeAssistantCount(detail) {
      return (
        detail.assignedAssistantCount || this.assignedAssistants(detail).length
      );
    },
    modalityIndicatorClass(detail) {
      return this.normalizedIsIndividual(detail)
        ? 'saee10-detail__classification-badge--individual'
        : 'saee10-detail__classification-badge--group';
    },
    modalityIndicatorText(detail) {
      return this.normalizedIsIndividual(detail) ? 'I' : 'G';
    },
    hasModalityIndicator(detail) {
      return this.normalizedIsIndividual(detail) !== null;
    },
    normalizedIsIndividual(detail) {
      const value = detail.isIndividual ?? detail.IsIndividual;

      if (value === true || value === 1 || value === '1') return true;
      if (value === false || value === 0 || value === '0') return false;

      if (typeof value === 'string') {
        const normalizedValue = value.toLowerCase();
        if (normalizedValue === 'true') return true;
        if (normalizedValue === 'false') return false;
      }

      return null;
    },
    onAssignmentOptionClick(detail, option) {
      if (!option.isAssistant) {
        this.$set(this.assistantSelectedIdsBySaee10Id, detail.id, []);
        this.$set(this.selectedAssignmentTypeBySaee10Id, detail.id, option.key);
        return;
      }

      this.$set(this.selectedAssignmentTypeBySaee10Id, detail.id, null);

      if (this.isAssistantSelected(detail, option.key)) {
        this.$set(
          this.assistantSelectedIdsBySaee10Id,
          detail.id,
          this.selectedAssistantIds(detail).filter((id) => id != option.key)
        );
      } else {
        this.$set(this.assistantSelectedIdsBySaee10Id, detail.id, [
          ...this.selectedAssistantIds(detail),
          option.key,
        ]);
      }
    },
    async onPrintReport(detail) {
      if (!detail.hrRequestId) {
        this.ShowToast(
          'Alerta',
          'El estudiante no cuenta con una solicitud.',
          'error'
        );
        return;
      }

      try {
        const report = await getRequestReport(false, detail.hrRequestId);
        generalService.documentDownloadReport(
          report.content,
          report.filename,
          report.contentType
        );
      } catch (err) {
        alert(err);
      }
    },
    saveAssistantSelection(detail) {
      if (!this.showAssistantSaveAction(detail)) return;

      const selectedAssignmentType = this.selectedAssignmentTypeBySaee10Id[
        detail.id
      ];

      this.openAssistantDropdownId = null;
      this.enabledAssistantDropdownIds = this.enabledAssistantDropdownIds.filter(
        (id) => id != detail.id
      );

      if (selectedAssignmentType == AssignmentTypeEnum.PendingAmendment) {
        this.$emit('pending-amendment', detail.id);
        return;
      }

      if (selectedAssignmentType == AssignmentTypeEnum.VacantPosition) {
        this.$emit('vacant-position', detail.id);
        return;
      }

      this.$emit(
        'assign-assistant',
        detail.id,
        [...this.selectedAssistantIds(detail)],
        detail.alternativeLocationTeacherId || undefined
      );
    },
    selectedAssistantIds(detail) {
      return this.assistantSelectedIdsBySaee10Id[detail.id] || [];
    },
    selectedAssistantNames(detail) {
      const names = this.selectedAssistantIds(detail)
        .map(
          (id) =>
            this.assignmentOptions(detail).find(
              (x) => x.isAssistant && x.key == id
            ) ||
            this.assignedAssistants(detail).find((x) => (x.id || x.Id) == id)
        )
        .filter(Boolean)
        .map((x) => x.value || x.name || x.Name)
        .join(', ');

      return names;
    },
    selectedOptionText(detail) {
      const selectedType = this.assignmentOptions(detail).find(
        (x) =>
          !x.isAssistant &&
          x.key == this.selectedAssignmentTypeBySaee10Id[detail.id]
      );

      return this.selectedAssistantNames(detail) || selectedType?.value || null;
    },
    showAssistantDropdown(detail) {
      if (!this.hasAssignmentPermission) return false;
      return this.enabledAssistantDropdownIds.includes(detail.id);
    },
    showAssistantSaveAction(detail) {
      return (
        this.hasAssistantSelectionChanges(detail) ||
        this.hasAssignmentTypeSelectionChanges(detail)
      );
    },
    showModalityChangeWarning(detail) {
      return (
        detail.hasIndividualModalityChangeWarning &&
        this.modalityChangeAssistantCount(detail) > 0
      );
    },
    showDropDownByRequest(detail) {
      return (
        detail.requestReturnInfo != null &&
        !detail.requestReturnInfo.recommendsExisting &&
        detail.requestReturnInfo.statusId == this.returnToSchool &&
        detail.statusId == Saee10StatusEnum.Process
      );
    },
    showTab(tabIndex) {
      this.open = true;
      this.activeTab = tabIndex;
    },
    toggleAssistantDropdown(detail) {
      if (this.isAssistantDropdownOpen(detail)) {
        this.openAssistantDropdownId = null;
        return;
      }

      if (!this.hasAssistantSelectionChanges(detail)) {
        this.initializeAssistantSelection(detail);
      }

      this.openAssistantDropdownId = detail.id;
    },
    toggleOpen() {
      this.open = !this.open;
      if (this.open) this.activeTab = 0;
    },
    closeAssistantDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.openAssistantDropdownId = null;
      }
    },
  },
  mounted() {
    this.initializeAllAssistantSelections();
    document.addEventListener('click', this.closeAssistantDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeAssistantDropdown);
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.initializeAllAssistantSelections();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.info-text-title {
  color: #727272;
  font-size: 13px;
  font-weight: normal;
}

p {
  color: #0b2b21;
  font-size: 14px;
  margin-bottom: 0;
}

.grouped-saee__row {
  align-items: center;
  display: grid;
  gap: 20px;
  grid-template-columns: 140px minmax(0, 1fr) 150px;
  padding: 18px 16px;
}

.grouped-saee__status {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 72px;
  padding-right: 18px;
}

.grouped-saee__status-pill,
.saee10-detail__status-pill {
  border-radius: 18px;
  display: inline-flex;
  font-weight: bold;
  height: 30px;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  padding: 0 14px;
  white-space: nowrap;
}

.saee10-detail__status-pill {
  min-width: max-content;
}

.grouped-saee__content {
  display: grid;
  gap: 12px 28px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grouped-saee__actions {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.grouped-saee__count {
  color: #727272;
  font-size: 13px;
  white-space: nowrap;
}

.white-container {
  background-color: white;
  border-radius: 5px;
}

.tab-container {
  background-color: #f7f7f7;
}

.custom-tab-font {
  --tab-font-size: 14px !important;
}

.additional-info {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding: 18px 28px;
}

.saee10-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.saee10-detail-wrapper {
  display: flex;
  flex-direction: column;
}

.saee10-detail {
  align-items: start;
  background: #f7f7f7;
  display: grid;
  gap: 20px;
  grid-template-columns: 250px 170px minmax(220px, 1fr) minmax(260px, 1.2fr) 42px 110px;
  min-height: 92px;
  padding: 18px 16px;
}

.saee10-detail__status {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.saee10-detail__field,
.saee10-detail__assistant,
.saee10-detail__actions {
  padding-top: 2px;
}

.saee10-detail__actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 22px;
}

.saee10-detail__classification {
  display: flex;
  justify-content: center;
  padding-top: 21px;
}

.saee10-detail__classification-badge {
  align-items: center;
  border: 2px solid;
  border-radius: 50%;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.saee10-detail__classification-badge--individual {
  background: #ffedbb;
  border-color: #f3af54;
  color: #f3af54;
  font-weight: 600;
}

.saee10-detail__classification-badge--group {
  background: #cef7e2;
  border-color: #2db782;
  color: #2db782;
  font-weight: 600;
}

.saee10-detail__modality-warning {
  margin-bottom: 0;
  margin-top: 0;
}

.assistant-assignment {
  align-items: center;
  display: flex;
  gap: 8px;
  max-width: 100%;
  width: 100%;
}

.assistant-readonly {
  color: #0b2b21;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assistant-multiselect {
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
}

.assistant-multiselect__button {
  align-items: center;
  background: #fff;
  border: 1px solid #d7dedb;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  min-height: 42px;
  min-width: 0;
  padding: 8px 12px;
  width: 100%;
}

.assistant-multiselect__text {
  color: #6f6f6f;
  display: block;
  flex: 1 1 auto;
  font-size: 14px;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assistant-multiselect__caret {
  color: #0b2b21;
  font-size: 12px;
  margin-left: 8px;
}

.assistant-multiselect__menu {
  background: #fff;
  border: 1px solid #d7dedb;
  border-radius: 4px;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.1);
  left: 0;
  max-height: 280px;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: calc(100% + 2px);
  z-index: 20;
}

.assistant-multiselect__option {
  align-items: center;
  background: #fff;
  border: 0;
  color: #0b2b21;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  min-height: 46px;
  padding: 8px 20px;
  text-align: left;
  width: 100%;
}

.assistant-multiselect__option:hover,
.assistant-multiselect__option--selected {
  background: #f1f3f1;
}

.assistant-multiselect__checkbox {
  align-items: center;
  background: #fff;
  border: 1px solid #d7dedb;
  border-radius: 5px;
  color: #fff;
  display: inline-flex;
  flex: 0 0 28px;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.assistant-multiselect__checkbox--checked {
  background: #2db782;
  border-color: #2db782;
}

.assistant-save-button {
  align-items: center;
  background: #2db782;
  border: 1px solid #2db782;
  border-radius: 4px;
  color: #fff;
  display: inline-flex;
  flex: 0 0 42px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.assistant-save-button:hover {
  background: #2b9d71;
  border-color: #2b9d71;
}

.assistant-save-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.assistant-cancel-button {
  align-items: center;
  background: #fff;
  border: 1px solid #e6525c;
  border-radius: 4px;
  color: #e6525c;
  display: inline-flex;
  flex: 0 0 42px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.assistant-cancel-button:hover {
  background: #fff5f6;
}

@media (max-width: 1200px) {
  .grouped-saee__row,
  .saee10-detail {
    grid-template-columns: 1fr;
  }

  .grouped-saee__content,
  .additional-info {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .grouped-saee__actions {
    align-items: flex-start;
  }
}
</style>
